import { useSharedStore } from '../store/sharedStore';

export const useUserPricingCurrency = () => {
  const userLocation = useSharedStore((state) => state.userLocation);
  const currency = useSharedStore((state) => state.pricingCurrency);
  const isLoading = useSharedStore((state) => state.isLoading);

  return { userLocation, currency, isLoading };
};
